// Matches Permission.Module in the database (see overwatch-api Scripts/*_SeedClientRoleRightSample.sql).
// Used both to tag MenuItem.permission (rfr-nav-admin) and route data.permission (AuthGuard).
export enum Permission {
    Dashboard = "Dashboard",
    RosterCalendar = "RosterCalendar",
    Chat = "Chat",
    VoiceComms = "VoiceComms",
    OnboardingReview = "OnboardingReview",
    LeaveRequests = "LeaveRequests",
    UsersAdmin = "UsersAdmin",
    UsersStaff = "UsersStaff",
    UsersWorkgroups = "UsersWorkgroups",
    UsersRolePermissions = "UsersRolePermissions",
    SetupAssignments = "SetupAssignments",
    SetupSites = "SetupSites",
    SetupShifts = "SetupShifts",
    SetupRosters = "SetupRosters",
    SetupTags = "SetupTags",
    SetupWorkPolicies = "SetupWorkPolicies",
    SetupOnboardingForms = "SetupOnboardingForms",
    AttendanceManagementRosterBased = "AttendanceManagementRosterBased",
    AttendanceManagementStaffBased = "AttendanceManagementStaffBased",
    AttendanceResolution = "AttendanceResolution",
    // System Admin
    ManageClient = "ManageClient",
    ManageAllUsers = "ManageAllUsers",
    ManageIssues = "ManageIssues",
    ManageBeacons = "ManageBeacons"
}
